import type { TableSortOrder } from "@/components/flexkit/tables/SortableTable";
import { SortOrder } from "gitpod-next-api/gitpod/v1/pagination_pb";

export function toApiSortOrder(sortOrder: TableSortOrder | undefined): SortOrder {
    switch (sortOrder) {
        case "asc":
            return SortOrder.ASC;
        case "desc":
            return SortOrder.DESC;
        default:
            return SortOrder.UNSPECIFIED;
    }
}
